import LeadList from '@/components/lead/LeadList'
import Lead from '@/components/lead/Lead'

export default [
  {
    path: '/leads',
    name: 'LeadList',
    component: LeadList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/leads/:id',
    name: 'LeadVue',
    component: Lead,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/leadRouter.js